export const SESSION_STORE_KEY = '_oo_s';
//# sourceMappingURL=sessionStoreStrategy.js.map